import moraleSurvey from './moraleSurvey';
import moraleSurveyResult from './moraleSurveyResult';

export default angular
  .module('App.morale', [])
  .component('moraleSurvey', moraleSurvey)
  .component('moraleSurveyResult', moraleSurveyResult).name;
